module.exports = __webpack_public_path__ + "img/abc.7a523f4b.svg";